import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';


export interface PontoCombinadoResponse {
  pontoIdPausa: string;
  pontoIdExpediente: string;
  id: string;
  tipoPonto: string;
  usuarioId: string;
  nome: string;
  inicioExpediente: string;
  fimExpediente: string;
  inicioPausa: string;
  retornoPausa: string;
  horasTrabalhadas: string;
  latitudeInicioExpediente: number;
  longitudeInicioExpediente: number;
  latitudeFimExpediente: number;
  longitudeFimExpediente: number;
  latitudeInicioPausa: number;
  longitudeInicioPausa: number;
  latitudeRetornoPausa: number;
  longitudeRetornoPausa: number;
}

@Injectable({
  providedIn: 'root'
})
export class PontoService {
  private apiUrl = `${environment.controllApp}/ponto`;

  constructor(private http: HttpClient) {}

  consultarTodosPontosCombinados(): Observable<PontoCombinadoResponse[]> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });

    const url = `${this.apiUrl}/pontos-combinados`;

    return this.http.get<PontoCombinadoResponse[]>(url, { headers });
  }
}
